import React, { useState, useContext, useMemo, useEffect } from "react";
import "../../Css/CheckoutService.css";
import { useAuth } from "../../Middleware/context/AuthContext";
import { db } from "../../Middleware/Firebase/firebase";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { StateContext } from "../../Middleware/context/StateProvider";
import {  useNavigate } from "react-router-dom";
import { FGetBankTouaki } from "../../Middleware/Firebase/FGetBankTouaki";




const CheckoutService = () => {
  const [paymentMethod, setPaymentMethod] = useState("fia");
  const [code, setCode] = useState(""); // <-- começa como string
  const [submitting, setSubmitting] = useState(false);
  const [bank, setBank] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);


  const { userProfile, user } = useAuth();
  const navigate = useNavigate();

//--------------interagir com funcao para obter dados


useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setLoading(true);
        const data = await FGetBankTouaki();
        if (alive) setBank(data);
      } catch (e) {
        if (alive) setErr(e.message || "Falha ao buscar dados bancários.");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

//-------------------------------------------------------------------------------------



  // O teu StateContext pode expor { state, dispatch }.
  // Pelo teu uso, parece que basket = useContext(StateContext) e basket?.state tem { basket: [...] }
  const basketContext = useContext(StateContext);
  const itemsState = basketContext?.state ?? {}; // { basket: [...] } ou {}
  const basket = Array.isArray(itemsState.basket) ? itemsState.basket : [];

  // Total (se no futuro tiver múltiplos produtos)
  const total = useMemo(
    () =>
      basket.reduce((sum, item) => {
        const price = Number(item?.price ?? 0);
        return sum + (isNaN(price) ? 0 : price);
      }, 0),
    [basket]
  );

  const askOrder = async () => {
    try {
      setSubmitting(true);

      // 1) Pré-validações
      if (!user?.uid) {
        alert("Precisas iniciar sessão para enviar o pedido.");
        return;
      }

      if (!Array.isArray(basket) || basket.length === 0) {
        alert("O carrinho está vazio.");
        return;
      }

      if (paymentMethod === "fia" && !code.trim()) {
        alert("Insere o código de referência do pagamento.");
        return;
      }

      
     

      const orderData = {
        requester: userProfile?.nome ?? user?.email ?? "Anónimo",
        requesterId: user.uid,
        whatsapp: userProfile?.telefone ?? "",
       items: itemsState,
       // paymentMethod,
        payCode: paymentMethod === "fia" ? code.trim() : "",
        total,
        createdAt: serverTimestamp(), // útil para ordenação
        status:"Pending",
      };
      
      
      // 3) Envia para o Firestore
      await addDoc(collection(db, "orders"), orderData);

      // 4) Feedback e navegação
      alert("O seu pedido foi enviado com sucesso!");
      setCode(""); // limpa o campo
      // Se tiveres dispatch para limpar o carrinho, podes chamar aqui, ex:
     basketContext?.dispatch?.({ type: "EMPTY_BASKET" });
      navigate("/");
    } catch (err) {
      console.error("Erro ao enviar pedido:", err);
      alert("Ocorreu um erro ao enviar o pedido. Tente novamente.");
    } finally {
      setSubmitting(false);
    }
  };

  // Renderização segura
  const firstItem = basket[0];
    const codeExpress=firstItem?.pagamentoReferencia;
  return (
    <div className="checkout-service-container">
      <h1 className="checkout-service-title">Finalizar Compra</h1>

      {/* Produtos */}
      <div className="checkout-service-products">
        <h2 className="checkout-service-subtitle">Resumo do Pedido</h2>

        {basket.length === 0 ? (
          <div className="checkout-service-product">
            <span>O carrinho está vazio.</span>
          </div>
        ) : (
          <>
            {/* Aqui está a lista completa dos itens, não apenas o primeiro */}
            {basket.map((prod) => (
              <div className="checkout-service-product" key={prod?.id}>
                <span>{prod?.nameProduto ?? prod?.name ?? "Produto"}</span>
                <strong>kz {Number(prod?.price ?? 0)}</strong>
              </div>
            ))}

            <div className="checkout-service-total">
              <span>Total</span>
              <strong>kz {total}</strong>
            </div>
          </>
        )}
      </div>

      {/* Pagamento */}
      <div className="checkout-service-payment">
        <h2 className="checkout-service-subtitle">Forma de Pagamento</h2>

        {/* Multicaixa Express */}
        <div className="checkout-service-payment-option">
          <label className="checkout-service-payment-label">
            <input
              type="radio"
              name="payment"
              value="fia"
              checked={paymentMethod === "fia"}
              onChange={(e) => setPaymentMethod(e.target.value)}
            />
            <span>Multicaixa Express ({codeExpress? codeExpress : "...Calculando"})</span>
          </label>

          {paymentMethod === "fia" && (
            <div className="checkout-service-payment-details">
              <p className="checkout-service-payment-text">
                Insira o código da sua transferência
              </p>
              <input
                type="text"
                className="checkout-service-payment-input"
                placeholder="Ex: 123456789"
                value={code}
                onChange={(e) => setCode(e.target.value)} // <-- simples e correto
              />
            </div>
          )}
        </div>

        {/* PayPal */}
        <div className="checkout-service-payment-option">
          <label className="checkout-service-payment-label">
            <input
              type="radio"
              name="payment"
              value="paypal"
              checked={paymentMethod === "paypal"}
              onChange={(e) => setPaymentMethod(e.target.value)}
            />
            <span>PayPal</span>
          </label>

          {paymentMethod === "paypal" && (
            <div className="checkout-service-payment-details">
              <p className="checkout-service-payment-text">
                Esta funcionalidade está indisponível.
              </p>
            </div>
          )}
        </div>

        {/* Visa */}
        <div className="checkout-service-payment-option">
          <label className="checkout-service-payment-label">
            <input
              type="radio"
              name="payment"
              value="visa"
              checked={paymentMethod === "visa"}
              onChange={(e) => setPaymentMethod(e.target.value)}
            />
            <span>Cartão Visa</span>
          </label>

          {paymentMethod === "visa" && (
            <div className="checkout-service-payment-details">
              <p className="checkout-service-payment-text">
                Método indisponível no momento
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Botão */}
      <button onClick={askOrder} className="checkout-service-button" disabled={submitting || basket.length === 0}>
        {submitting ? "A enviar..." : "Confirmar Pagamento"}
      </button>

      <p className="checkout-service-secure">🔒 Pagamento 100% seguro</p>
    </div>
  );
};

export default CheckoutService;
